import { render } from "./IndicationsPage.vue?vue&type=template&id=85130968"
import script from "./IndicationsPage.vue?vue&type=script&lang=js"
export * from "./IndicationsPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__